var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sales w-full flex justify-center items-center"},[_c('div',{staticClass:"sales_box"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }